import { Action, createReducer, on } from '@ngrx/store';
import * as actions from 'src/app/root-store/account-managers-submittals-store/actions';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import { SubmittalClientNotesState } from 'src/app/root-store/account-managers-submittals-store/state/submittals-clientnotes-state';

export const initialState: SubmittalClientNotesState = {
    isLoading: LoadingTypes.INIT,
    notes: [],
    submittalIds: [],
    error: undefined
};

const reducer = createReducer(
    initialState,
    on(
        actions.setSubmittalClientNotesFilter,
        (state, action): SubmittalClientNotesState => ({
            ...state,
            submittalIds: action.submittalIds,
            notes: [],
            isLoading: LoadingTypes.LOADING
        })
    ),

    on(
        actions.loadSubmittalClientNotesSuccess,
        (state, action): SubmittalClientNotesState => ({
            ...state,
            notes: action.notes,
            isLoading: LoadingTypes.LOADED
        })
    ),

    on(
        actions.loadSubmittalClientNotesFail,
        (state): SubmittalClientNotesState => ({
            ...state,
            isLoading: LoadingTypes.FAIL
        })
    ),

    on(
        actions.postSubmittalReply,
        (state): SubmittalClientNotesState => ({
            ...state,
            isLoading: LoadingTypes.LOADING
        })
    ),

    on(
        actions.postSubmittalReplySuccess,
        (state): SubmittalClientNotesState => ({
            ...state,
            isLoading: LoadingTypes.LOADED
        })
    ),

    on(
        actions.postSubmittalReplyFail,
        (state, action): SubmittalClientNotesState => ({
            ...state,
            isLoading: LoadingTypes.FAIL,
            error: action.error
        })
    )
);

export function submittalClientNotesReducer(state: SubmittalClientNotesState | undefined, action: Action) {
    return reducer(state, action);
}
